import type { IconProps } from './Icon.types';

const PinIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width = 13,
  height = 17,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 16.125C4.125 14.0938 0.5 9.25 0.5 6.5C0.5 3.1875 3.15625 0.5 6.5 0.5C9.8125 0.5 12.5 3.1875 12.5 6.5C12.5 9.25 8.84375 14.0938 7.21875 16.125C6.84375 16.5938 6.125 16.5938 5.75 16.125ZM6.5 8.5C7.59375 8.5 8.5 7.625 8.5 6.5C8.5 5.40625 7.59375 4.5 6.5 4.5C5.375 4.5 4.5 5.40625 4.5 6.5C4.5 7.625 5.375 8.5 6.5 8.5Z"
      fill={fill}
    />
  </svg>
);

export default PinIcon;
